import React from 'react'
import { UseFormReturnType } from '@mantine/form'
import * as CONSTANTS from '../../../../constants/pdf-report-download'
import { PDFOptionsForm } from '../../../../lib/types/ReportDownload.type'
import { Button, ColorPicker, Group, Popover, Select, TextInput } from '@mantine/core'

type HeaderFooterOptionProps = {
  label: string
  field: 'header1' | 'header2' | 'footer'
  form: UseFormReturnType<PDFOptionsForm>
}

export const HeaderFooterOption = ({ label, field, form }: HeaderFooterOptionProps) => {
  return (
    <Group align='flex-end' w='100%' wrap='nowrap'>
      <TextInput c={form.getValues()[`${field}_color`]} styles={{ input: { color: form.getValues()[`${field}_color`] }}} label={label} w='300px' {...form.getInputProps(`${field}_text`)} key={form.key(`${field}_text`)} />
      <Select label='Font' data={CONSTANTS.FONTS} {...form.getInputProps(`${field}_font`)} key={form.key(`${field}_font`)} />
      <Select label='Size' data={CONSTANTS.HEADER_SIZES} {...form.getInputProps(`${field}_font_size`)} key={form.key(`${field}_font_size`)}  />
      <Select label='Style' data={CONSTANTS.HEADER_STYLES} {...form.getInputProps(`${field}_font_style`)} key={form.key(`${field}_font_style`)}  />
      <Select label='Position' data={CONSTANTS.POSITIONS} {...form.getInputProps(`${field}_position`)} key={form.key(`${field}_position`)}  />
      <Popover position="bottom-end" offset={0} shadow="md">
        <Popover.Target>
          <Button w='7rem' variant='outline'>Color</Button>
        </Popover.Target>
        <Popover.Dropdown p={0}>
          <ColorPicker format="hex" {...form.getInputProps(`${field}_color`)} key={form.key(`${field}_color`)} swatches={CONSTANTS.SWATCHES} />
        </Popover.Dropdown>
      </Popover>
    </Group>
  )
}
